import React, { useEffect, useState } from "react";
import "./CandidateDetail.scss";
import { useNavigate, useParams } from "react-router-dom";
import {
  adminCandidateReportSummary,
  adminCandidateReportDetails,
  jobseekerIdChangeRequest,
} from "../../redux/actions/VendorCandidateDetails";
import { useDispatch, useSelector } from "react-redux";
import CandidateReportSummary from "./SubDetails/CandidateReportSummary";
import CandidateHistory from "./SubDetails/CandidateHistory";
import CandidateDocuments from "./SubDetails/CandidateDocuments";
import CandidateApplicantData from "./SubDetails/CandidateApplicantData";
import CandidateReportOverall from "./SubDetails/CandidateReportOverall";
import CandidateRequests from "./SubDetails/CandidateRequests";
import FullPageLoader from "../Loader/FullPageLoader";
import UpdateTooltip from "../../assets/images/UpdateTooltip.png";
import RequestedTooltip from "../../assets/images/RequestedTooltip.png";
import ButtonSpinner from "../ReusableComponents/ButtonSpinner";

const CandidateDetail = () => {
  const DarkMode = localStorage.getItem("Theme") === "true" ? true : false;
  const dispatch = useDispatch();
  const [currentTab, setCurrentTab] = useState("ReportSummary");
  const [CandidateReportDetails, setCandidateReportDetails] = useState("");
  const { username, clientinfo } = useParams();
  const [trigger, setTrigger] = useState(0);
  const navigate = useNavigate();
  const [ShowUpdateTooltip, setShowUpdateTooltip] = useState({
    x: 0,
    y: 0,
    showHide: false,
  });
  const [ShowRequestTooltip, setShowRequestTooltip] = useState({
    x: 0,
    y: 0,
    showHide: false,
  });
  const [UpdateJobseekerId, setUpdateJobseekerId] = useState({
    value: "",
    showHide: false,
  });

  const candidateDetails = useSelector(
    (state) => state.adminCandidateReportSummary?.data?.data
  );
  const adminCandidateReportLoading = useSelector(
    (state) => state?.adminCandidateReportDetails?.loading
  );
  const jobseekerIdChangeRequestLoading = useSelector(
    (state) => state.jobseekerIdChangeRequest?.loading
  );
  const isMaster = localStorage.getItem("IsMaster") === "1";

  const candidateDetailsHeader =
    candidateDetails && candidateDetails?.report_details?.report_summary;

  // useEffect(()=>{
  //   if(activeData) {
  //     console.log("ACtive data1")
  //     fetchCandidateDetails();
  //     // setCurrentTab("ApplicantData")
  //   }
  // },[activeData])

  const fetchCandidateDetails = () => {
    const data = {
      Candidate_username: username,
      client_info_id: clientinfo,
    };

    const successFn = (response) => {
      console.log("response::::SDSD",response);
      console.log("fetchCandidateDetails::::::::", response.data);
      // if(activeData) {
      //   setCurrentTab("ApplicantData")
      //   console.log("ACtive data2")
      // }
    };

    const failureFn = (error) => {
      console.error("Logged-in failed", error);
    };

    dispatch(adminCandidateReportSummary({ data, successFn, failureFn }));
  };
  const GetCandidateDetails = () => {
    const data = {
      Candidate_username: username,
      client_info_id: clientinfo,
    };

    const successFn = (response) => {
      console.log("CandidateReportDetails::::::::", response.data);
      setCandidateReportDetails(response.data);
    };

    const failureFn = (error) => {
      console.error("GetCandidateDetails failed", error);
    };

    dispatch(adminCandidateReportDetails({ data, successFn, failureFn }));
  };

  useEffect(() => {
    fetchCandidateDetails();
    GetCandidateDetails();
  }, [trigger, username, clientinfo]);

  const handleKeyDown = (e) => {
    if (e.key === "Escape") {
      setUpdateJobseekerId({
        value: "",
        showHide: false,
      });
    }
  };

  const handleMouseEnterUpdateInfo = (e) => {
    const rect = e.target.getBoundingClientRect();
    setShowUpdateTooltip((prev) => ({
      ...prev,
      x: rect.x,
      y: rect.y,
      showHide: true,
    }));
  };
  const handleMouseLeaveUpdateInfo = () => {
    setShowUpdateTooltip({
      x: 0,
      y: 0,
      showHide: false,
    });
  };

  const handleMouseEnterRequestedInfo = (e) => {
    const rect = e.target.getBoundingClientRect();
    setShowRequestTooltip((prev) => ({
      ...prev,
      x: rect.x,
      y: rect.y,
      showHide: true,
    }));
  };
  const handleMouseLeaveRequestedInfo = (e) => {
    setShowRequestTooltip({
      x: 0,
      y: 0,
      showHide: false,
    });
  };

  const handleJobseekerIdRequest = () => {
    if (
      !candidateDetailsHeader.request_number &&
      !username &&
      !UpdateJobseekerId.value
    ) {
      return;
    }

    if (!UpdateJobseekerId.value?.trim()) {
      alert("Jobseeker Id should not be empty");
      return;
    }

    const data = {
      candidate_username: username,
      request_number: candidateDetailsHeader?.request_number,
      new_job_seeker_id: UpdateJobseekerId.value,
    };

    const successFn = (response) => {
      alert(response.message);
      setUpdateJobseekerId({
        value: "",
        showHide: false,
      });
      setTrigger((prev) => prev + 1);
    };

    const failureFn = (error) => {
      console.error("Jobseeker Id Change Request failed", error);
    };

    dispatch(jobseekerIdChangeRequest({ data, successFn, failureFn }));
  };

  const rendeCandidateDetailsComponent = () => {
    if (currentTab === "ReportSummary") {
      return (
        <CandidateReportSummary
          fetchCandidateDetails={fetchCandidateDetails}
          details={
            candidateDetails?.report_details?.report_summary?.information_needed
          }
          setTrigger={setTrigger}
        />
      );
    } else if (currentTab === "History") {
      return (
        <CandidateHistory details={candidateDetails?.report_details?.history} />
      );
    } else if (currentTab === "Documents") {
      return (
        <CandidateDocuments
          details={candidateDetails?.report_details?.documents}
        />
      );
    } else if (currentTab === "ApplicantData") {
      return (
        <CandidateApplicantData
          details={candidateDetails?.report_details?.application_data}
          fetchCandidateDetails = {fetchCandidateDetails}
        />
      );
    } else if (currentTab === "ReportDetails") {
      return (
        <CandidateReportOverall
          overallReport={CandidateReportDetails?.report_details?.report_url}
          courtReport={CandidateReportDetails?.report_details?.court_report_url}
          viewOverallReport={CandidateReportDetails?.candidate_report_status}
        />
      );
    } else if (currentTab === "Requests") {
      return (
        <CandidateRequests
          details={candidateDetails?.report_details?.insufficient_data}
          additionalData={candidateDetails?.report_details?.additional_cost}
          setTrigger={() => setTrigger(trigger + 1)}
        />
      );
    } else {
      return null;
    }
  };

  return (
    <main className='CandidateDetail'>
      {adminCandidateReportLoading ? (
        <FullPageLoader />
      ) : (
        <>
          <div
            className='Back'
            onClick={() => {
              navigate(-1);
            }}>
            <svg
              xmlns='http://www.w3.org/2000/svg'
              width='0.875rem'
              height='0.875rem'
              viewBox='0 0 38 38'
              fill='none'>
              <path
                d='M29.5556 16.2555H13.5112L20.4778 9.28884C21.3223 8.4444 21.3223 7.17773 20.4778 6.33328C19.6334 5.48884 18.3667 5.48884 17.5223 6.33328L6.96671 16.8888C6.12226 17.7333 6.12226 19 6.96671 19.8444L17.5223 30.4C18.3667 31.2444 19.6334 31.2444 20.4778 30.4C21.3223 29.5555 21.3223 28.2888 20.4778 27.4444L13.5112 20.4777H29.5556C30.8223 20.4777 31.6667 19.6333 31.6667 18.3666C31.6667 17.3111 30.8223 16.2555 29.5556 16.2555Z'
                fill='#102C98'
              />
            </svg>
            <span>Back</span>
          </div>
          <header className='DetailsNavigation'>
            <section className='DetailsSection'>
              <div className='NameStatus'>
                <h1 className='Name'>{candidateDetailsHeader?.user_name}</h1>
                <div className='CurrentStatus'>
                  <span>Status</span>
                  <span className={`Status ${candidateDetailsHeader?.status}`}>
                    {candidateDetailsHeader?.status}
                  </span>
                </div>
              </div>
              <div className='Details'>
                <div className='LabelValue'>
                  <span className='Label'>
                    <svg
                      xmlns='http://www.w3.org/2000/svg'
                      width='1.25rem'
                      height='1.25rem'
                      viewBox='0 0 25 25'
                      fill='none'>
                      <path
                        d='M12.5 11.4583C13.3241 11.4583 14.1297 11.214 14.8149 10.7561C15.5001 10.2983 16.0341 9.64754 16.3495 8.88618C16.6649 8.12482 16.7474 7.28705 16.5866 6.47879C16.4258 5.67054 16.029 4.92811 15.4463 4.34539C14.8636 3.76267 14.1211 3.36583 13.3129 3.20506C12.5046 3.04429 11.6669 3.12681 10.9055 3.44217C10.1441 3.75754 9.49339 4.29159 9.03555 4.97679C8.57771 5.662 8.33334 6.46758 8.33334 7.29167C8.33334 8.39674 8.77233 9.45655 9.55373 10.2379C10.3351 11.0193 11.3949 11.4583 12.5 11.4583ZM12.5 5.20833C12.9121 5.20833 13.3148 5.33052 13.6574 5.55944C14 5.78836 14.2671 6.11373 14.4248 6.49441C14.5824 6.87509 14.6237 7.29398 14.5433 7.69811C14.4629 8.10223 14.2645 8.47345 13.9731 8.76481C13.6818 9.05617 13.3106 9.25459 12.9064 9.33497C12.5023 9.41536 12.0834 9.3741 11.7028 9.21642C11.3221 9.05873 10.9967 8.79171 10.7678 8.44911C10.5389 8.1065 10.4167 7.70371 10.4167 7.29167C10.4167 6.73913 10.6362 6.20923 11.0269 5.81853C11.4176 5.42783 11.9475 5.20833 12.5 5.20833ZM12.5 13.5417C10.5661 13.5417 8.71148 14.3099 7.34402 15.6773C5.97657 17.0448 5.20834 18.8995 5.20834 20.8333C5.20834 21.1096 5.31809 21.3746 5.51344 21.5699C5.70879 21.7653 5.97374 21.875 6.25001 21.875C6.52628 21.875 6.79123 21.7653 6.98658 21.5699C7.18193 21.3746 7.29168 21.1096 7.29168 20.8333C7.29168 19.452 7.84041 18.1272 8.81716 17.1505C9.79391 16.1737 11.1187 15.625 12.5 15.625C13.8813 15.625 15.2061 16.1737 16.1829 17.1505C17.1596 18.1272 17.7083 19.452 17.7083 20.8333C17.7083 21.1096 17.8181 21.3746 18.0134 21.5699C18.2088 21.7653 18.4737 21.875 18.75 21.875C19.0263 21.875 19.2912 21.7653 19.4866 21.5699C19.6819 21.3746 19.7917 21.1096 19.7917 20.8333C19.7917 18.8995 19.0234 17.0448 17.656 15.6773C16.2885 14.3099 14.4339 13.5417 12.5 13.5417Z'
                        fill='var(--TextColor)'
                      />
                    </svg>
                    <span>Requested By :</span>
                  </span>
                  <span className='Value'>
                    {candidateDetailsHeader?.requested_by}
                  </span>
                </div>
                <div className='LabelValue'>
                  <span className='Label'>
                    <svg
                      xmlns='http://www.w3.org/2000/svg'
                      width='1.25rem'
                      height='1.25rem'
                      viewBox='0 0 25 25'
                      fill='none'>
                      <path
                        d='M8.54545 16C8.40079 16 8.26205 16.0527 8.15976 16.1464C8.05747 16.2402 8 16.3674 8 16.5C8 16.6326 8.05747 16.7598 8.15976 16.8536C8.26205 16.9473 8.40079 17 8.54545 17H11.4545C11.5992 17 11.7379 16.9473 11.8402 16.8536C11.9425 16.7598 12 16.6326 12 16.5C12 16.3674 11.9425 16.2402 11.8402 16.1464C11.7379 16.0527 11.5992 16 11.4545 16H8.54545Z'
                        fill='var(--TextColor)'
                      />
                      <path
                        fillRule='evenodd'
                        clipRule='evenodd'
                        d='M10.0769 4H14.9231C15.7192 4 16.3685 4 16.8968 4.05805C17.4466 4.11941 17.9242 4.24878 18.3563 4.54649C18.79 4.84337 19.0819 5.24307 19.3365 5.73483C19.5803 6.20585 19.8133 6.81122 20.0994 7.55507L20.6459 8.97561C20.7935 9.35873 20.8947 9.6241 20.9478 9.90605C21 10.188 21 10.4733 21 10.8829V15.448C21 16.5817 21 17.4963 20.9038 18.2153C20.8026 18.9617 20.5887 19.5902 20.0895 20.0895C19.5902 20.5887 18.9617 20.8026 18.2153 20.9038C17.4963 21 16.5817 21 15.448 21H9.55195C8.41834 21 7.50366 21 6.78468 20.9038C6.03834 20.8026 5.40976 20.5887 4.91054 20.0895C4.41132 19.5902 4.19737 18.9617 4.09702 18.2153C4 17.4963 4 16.5817 4 15.448V10.8829C4 10.4733 4 10.1888 4.05224 9.90605C4.10449 9.6241 4.20649 9.35873 4.3541 8.97561L4.90059 7.55507C5.18668 6.81122 5.41971 6.20585 5.66351 5.73483C5.9181 5.24224 6.21083 4.84337 6.64288 4.54649C7.07576 4.24878 7.55341 4.11941 8.10405 4.05805C8.63146 4 9.27995 4 10.0777 4H10.0769ZM8.24088 5.29449C7.80551 5.34341 7.55093 5.43215 7.34776 5.57146C7.14376 5.71161 6.96961 5.91727 6.7681 6.3062C6.55995 6.70922 6.35098 7.2499 6.04912 8.03439L5.52751 9.39024H19.4725L18.9509 8.03439C18.649 7.2499 18.44 6.70922 18.2319 6.3062C18.0304 5.91644 17.8562 5.71161 17.6522 5.57146C17.4491 5.43215 17.1945 5.34341 16.7591 5.29449C16.308 5.24473 15.7283 5.2439 14.8875 5.2439H10.1125C9.27166 5.2439 8.692 5.24473 8.24088 5.29449ZM5.2439 10.936L5.24473 10.6341H19.7553L19.7561 10.936V15.4024C19.7561 16.5924 19.7544 17.4225 19.6707 18.0495C19.5886 18.6581 19.4385 18.9799 19.2096 19.2096C18.9799 19.4393 18.6581 19.5886 18.0486 19.6707C17.4225 19.7544 16.5924 19.7561 15.4024 19.7561H9.59756C8.40756 19.7561 7.57663 19.7544 6.95054 19.6707C6.34185 19.5886 6.0201 19.4385 5.79039 19.2096C5.56068 18.9799 5.41141 18.6581 5.32932 18.0486C5.24556 17.4225 5.2439 16.5924 5.2439 15.4024V10.936Z'
                        fill='var(--TextColor)'
                      />
                    </svg>
                    <span>Package :</span>
                  </span>
                  <span className='Value'>
                    {candidateDetailsHeader?.package_name?.length > 0 &&
                    Array.isArray(candidateDetailsHeader?.package_name)
                      ? candidateDetailsHeader?.package_name?.join(" ,")
                      : candidateDetailsHeader?.package_name}
                  </span>
                </div>
                <div className='LabelValue'>
                  <span className='Label'>
                    <svg
                      xmlns='http://www.w3.org/2000/svg'
                      width='1.25rem'
                      height='1.25rem'
                      viewBox='0 0 25 25'
                      fill='none'>
                      <path
                        fillRule='evenodd'
                        clipRule='evenodd'
                        d='M14.016 19.6226C13.5269 19.7265 13.0196 19.781 12.5 19.781C8.47598 19.781 5.2093 16.5001 5.2093 12.4585C5.2093 11.8465 4.71442 11.349 4.10465 11.349C3.49488 11.349 3 11.8465 3 12.4585C3 17.7249 7.25688 22 12.5 22C13.1765 22 13.8366 21.929 14.4734 21.7936C15.0699 21.6667 15.4516 21.0773 15.3252 20.4782C15.1993 19.8791 14.6125 19.4957 14.016 19.6226ZM13.5273 5.20823C17.0658 5.70972 19.7907 8.76745 19.7907 12.4585C19.7907 15.0697 18.4267 17.3637 16.376 18.6605C15.8599 18.9867 15.7048 19.6723 16.03 20.1902C16.3548 20.7086 17.0375 20.8643 17.5531 20.5381C20.2242 18.8486 22 15.8601 22 12.4585C22 7.6482 18.4474 3.66473 13.8362 3.01102C13.2326 2.92537 12.6732 3.34829 12.5879 3.95451C12.5026 4.56073 12.9237 5.12258 13.5273 5.20823ZM5.7338 9.72737C6.51501 7.77957 8.10659 6.24537 10.0879 5.54685C10.6632 5.34403 10.9659 4.71029 10.7639 4.13247C10.562 3.55466 9.93103 3.25023 9.35617 3.45304C6.77526 4.36281 4.70249 6.36121 3.68445 8.89837C3.45689 9.46642 3.73085 10.1135 4.29643 10.342C4.86201 10.571 5.50624 10.2954 5.7338 9.72737Z'
                        fill='var(--TextColor)'
                      />
                    </svg>
                    <span>Request Number :</span>
                  </span>
                  <span className='Value'>
                    {candidateDetailsHeader?.request_number}
                  </span>
                </div>
                <div className='LabelValue'>
                  <span className='Label'>
                    <svg
                      xmlns='http://www.w3.org/2000/svg'
                      width='1.25rem'
                      height='1.25rem'
                      viewBox='0 0 24 24'
                      fill='none'>
                      <path
                        fillRule='evenodd'
                        clipRule='evenodd'
                        d='M5.94849 5.73688C6.57805 5.65171 7.34898 5.63678 8.2762 5.63502C8.33129 4.91806 8.65502 4.24833 9.18264 3.75978C9.71026 3.27123 10.4029 2.99988 11.122 3H12.878C13.5968 3.00008 14.2891 3.27141 14.8165 3.75976C15.3439 4.2481 15.6676 4.91749 15.7229 5.63415C16.651 5.63678 17.422 5.65171 18.0515 5.73688C18.8418 5.84224 19.5073 6.07054 20.0359 6.59824C20.5645 7.12683 20.791 7.79239 20.8981 8.58263C21 9.3439 21 10.3124 21 11.5127V15.1215C21 16.3218 21 17.2902 20.8981 18.0515C20.791 18.8418 20.5645 19.5073 20.0359 20.0359C19.5073 20.5645 18.8418 20.791 18.0515 20.8981C17.2902 21 16.3218 21 15.1215 21H8.87854C7.67824 21 6.70976 21 5.94849 20.8981C5.15824 20.791 4.49268 20.5645 3.9641 20.0359C3.43551 19.5073 3.20898 18.8418 3.10273 18.0515C3 17.2902 3 16.3218 3 15.1215V11.5127C3 10.3124 3 9.3439 3.10273 8.58263C3.2081 7.79239 3.43639 7.12683 3.9641 6.59824C4.49268 6.06966 5.15824 5.84312 5.94849 5.73688ZM14.3988 5.63415H9.60117C9.65395 5.26845 9.83674 4.93401 10.116 4.69212C10.3954 4.45023 10.7525 4.31708 11.122 4.31707H12.878C13.2475 4.31708 13.6046 4.45023 13.884 4.69212C14.1633 4.93401 14.346 5.26845 14.3988 5.63415ZM6.1241 19.5925C5.47961 19.5056 5.13893 19.3466 4.89571 19.1043C4.65249 18.8611 4.49444 18.5204 4.40751 17.875C4.31883 17.2121 4.31707 16.3332 4.31707 15.0732V12.1141C5.69473 12.6919 6.82829 13.159 7.82927 13.5111V14.6341C7.82927 14.8088 7.89865 14.9763 8.02215 15.0998C8.14565 15.2233 8.31315 15.2927 8.4878 15.2927C8.66246 15.2927 8.82996 15.2233 8.95346 15.0998C9.07696 14.9763 9.14634 14.8088 9.14634 14.6341V13.9273C10.2559 14.2429 11.4101 14.372 12.562 14.3093C13.3144 14.2741 14.052 14.146 14.8537 13.9273V14.6341C14.8537 14.8088 14.923 14.9763 15.0465 15.0998C15.17 15.2233 15.3375 15.2927 15.5122 15.2927C15.6868 15.2927 15.8544 15.2233 15.9779 15.0998C16.1014 14.9763 16.1707 14.8088 16.1707 14.6341V13.5111C17.1717 13.1581 18.3053 12.6919 19.6829 12.1133V15.0732C19.6829 16.3332 19.6812 17.2121 19.5925 17.8759C19.5056 18.5204 19.3466 18.8611 19.1043 19.1043C18.8611 19.3475 18.5204 19.5056 17.875 19.5925C17.2121 19.6812 16.3332 19.6829 15.0732 19.6829H8.92683C7.66683 19.6829 6.78702 19.6812 6.1241 19.5925ZM9.14634 12.5584C10.0103 12.8183 10.7479 12.9588 11.4995 12.9931C11.8332 13.0089 12.1668 13.0089 12.5005 12.9931C13.2521 12.958 13.9905 12.8175 14.8537 12.5584V11.561C14.8537 11.3863 14.923 11.2188 15.0465 11.0953C15.17 10.9718 15.3375 10.9024 15.5122 10.9024C15.6868 10.9024 15.8544 10.9718 15.9779 11.0953C16.1014 11.2188 16.1707 11.3863 16.1707 11.561V12.1098C17.1304 11.7533 18.2614 11.2826 19.6812 10.6856C19.6768 9.87512 19.6592 9.2561 19.5925 8.75824C19.5056 8.11376 19.3466 7.77307 19.1043 7.52985C18.8611 7.28663 18.5204 7.12859 17.875 7.04166C17.2121 6.95298 16.3332 6.95122 15.0732 6.95122H8.92683C7.66683 6.95122 6.78702 6.95298 6.1241 7.04166C5.47961 7.12859 5.13893 7.28751 4.89571 7.52985C4.65249 7.77307 4.49444 8.11376 4.40751 8.75912C4.34078 9.2561 4.32322 9.87424 4.31883 10.6856C5.73863 11.2826 6.86956 11.7533 7.82927 12.1098V11.561C7.82927 11.3863 7.89865 11.2188 8.02215 11.0953C8.14565 10.9718 8.31315 10.9024 8.4878 10.9024C8.66246 10.9024 8.82996 10.9718 8.95346 11.0953C9.07696 11.2188 9.14634 11.3863 9.14634 11.561V12.5584Z'
                        fill='var(--TextColor)'
                      />
                    </svg>
                    <span>Jobseeker Id :</span>
                  </span>
                  <span className='Value'>
                    {!candidateDetailsHeader?.requested_jobseeker_id ||
                    candidateDetailsHeader?.job_seeker_id ===
                      candidateDetailsHeader?.requested_jobseeker_id ? (
                      UpdateJobseekerId.showHide ? (
                        <form
                          className='SubmitJobseekerId'
                          onKeyDown={handleKeyDown}
                          onSubmit={(e) => {
                            e.preventDefault();
                            handleJobseekerIdRequest();
                          }}>
                          <div>
                            <input
                              type='text'
                              value={UpdateJobseekerId.value}
                              autoFocus
                              onKeyDown={handleKeyDown}
                              onChange={(e) => {
                                setUpdateJobseekerId((prev) => ({
                                  ...prev,
                                  value: e.target.value,
                                }));
                              }}
                              onInput={(e) => {
                                const value = e.target.value;

                                const validRegex = /^[A-Za-z0-9_-]*$/;

                                if (!validRegex.test(value)) {
                                  e.target.value = value.replace(
                                    /[^A-Za-z0-9_-]/g,
                                    ""
                                  );
                                }
                              }}
                            />
                            <svg
                              xmlns='http://www.w3.org/2000/svg'
                              width='0.625rem'
                              height='0.625rem'
                              viewBox='0 0 9 9'
                              fill='none'
                              onClick={() => {
                                setUpdateJobseekerId({
                                  value: "",
                                  showHide: false,
                                });
                              }}>
                              <path
                                d='M3.7362 4.49961L0.323703 1.09253C0.221705 0.990531 0.164403 0.852192 0.164403 0.707945C0.164403 0.563699 0.221705 0.42536 0.323703 0.323362C0.4257 0.221364 0.564039 0.164062 0.708285 0.164062C0.852532 0.164062 0.99087 0.221364 1.09287 0.323362L4.49995 3.73586L7.90704 0.323362C8.00903 0.221364 8.14737 0.164063 8.29162 0.164063C8.43587 0.164063 8.5742 0.221364 8.6762 0.323362C8.7782 0.42536 8.8355 0.563699 8.8355 0.707945C8.8355 0.852192 8.7782 0.990531 8.6762 1.09253L5.2637 4.49961L8.6762 7.9067C8.72697 7.95705 8.76727 8.01696 8.79477 8.08297C8.82227 8.14897 8.83643 8.21977 8.83643 8.29128C8.83643 8.36278 8.82227 8.43358 8.79477 8.49959C8.76727 8.5656 8.72697 8.62551 8.6762 8.67586C8.62585 8.72663 8.56594 8.76693 8.49993 8.79443C8.43392 8.82193 8.36312 8.83609 8.29162 8.83609C8.22011 8.83609 8.14931 8.82193 8.08331 8.79443C8.0173 8.76693 7.95739 8.72663 7.90704 8.67586L4.49995 5.26336L1.09287 8.67586C1.04251 8.72663 0.982605 8.76693 0.916598 8.79443C0.850591 8.82193 0.779792 8.83609 0.708285 8.83609C0.636779 8.83609 0.56598 8.82193 0.499973 8.79443C0.433966 8.76693 0.374058 8.72663 0.323703 8.67586C0.272933 8.62551 0.232635 8.5656 0.205135 8.49959C0.177636 8.43358 0.163478 8.36278 0.163478 8.29128C0.163478 8.21977 0.177636 8.14897 0.205135 8.08297C0.232635 8.01696 0.272933 7.95705 0.323703 7.9067L3.7362 4.49961Z'
                                fill='#212121'
                              />
                            </svg>
                          </div>
                          <button type='submit'>
                            {jobseekerIdChangeRequestLoading ? (
                              <ButtonSpinner />
                            ) : (
                              "Submit"
                            )}
                          </button>
                        </form>
                      ) : (
                        <div className='JobseekerId'>
                          <span title={candidateDetailsHeader?.job_seeker_id}>
                            {candidateDetailsHeader?.job_seeker_id}
                          </span>
                          {!isMaster && (
                            <>
                              <button
                                onClick={() => {
                                  candidateDetailsHeader?.status !==
                                    "cancelled" &&
                                    setUpdateJobseekerId((prev) => ({
                                      ...prev,
                                      showHide: true,
                                    }));
                                }}>
                                Update
                                <svg
                                  xmlns='http://www.w3.org/2000/svg'
                                  width='0.75rem'
                                  height='0.75rem'
                                  viewBox='0 0 12 12'
                                  fill='none'>
                                  <path
                                    d='M10 5.74246L5.89623 9.84623C5.69121 10.0513 5.35879 10.0513 5.15377 9.84623C4.94874 9.64121 4.94874 9.30879 5.15377 9.10377L9.25754 5H7.5C7.22386 5 7 4.77614 7 4.5C7 4.22386 7.22386 4 7.5 4H10.5C10.7761 4 11 4.22386 11 4.5V7.5C11 7.77614 10.7761 8 10.5 8C10.2239 8 10 7.77614 10 7.5V5.74246ZM2 6.25754L6.10377 2.15377C6.30879 1.94874 6.64121 1.94874 6.84623 2.15377C7.05126 2.35879 7.05126 2.69121 6.84623 2.89623L2.74246 7H4.5C4.77614 7 5 7.22386 5 7.5C5 7.77614 4.77614 8 4.5 8H1.5C1.22386 8 1 7.77614 1 7.5V4.5C1 4.22386 1.22386 4 1.5 4C1.77614 4 2 4.22386 2 4.5V6.25754Z'
                                    fill='var(--AccentColor)'
                                  />
                                </svg>
                              </button>
                              <svg
                                xmlns='http://www.w3.org/2000/svg'
                                width='1.25rem'
                                height='1.25rem'
                                viewBox='0 0 16 16'
                                fill='none'
                                onMouseEnter={handleMouseEnterUpdateInfo}
                                onMouseLeave={handleMouseLeaveUpdateInfo}>
                                <path
                                  d='M8 5.87511C7.91783 5.87544 7.83641 5.8595 7.76043 5.82821C7.68445 5.79691 7.61542 5.75089 7.55732 5.69279C7.49922 5.63468 7.45319 5.56565 7.4219 5.48968C7.39061 5.4137 7.37467 5.33228 7.375 5.25011C7.37545 5.20898 7.37964 5.16798 7.3875 5.12761C7.40285 5.04714 7.43431 4.9706 7.48 4.90261C7.50306 4.86877 7.52898 4.83699 7.5575 4.80761C7.67747 4.6953 7.83566 4.63281 8 4.63281C8.16434 4.63281 8.32253 4.6953 8.4425 4.80761C8.5585 4.9258 8.62395 5.0845 8.625 5.25011C8.62869 5.29086 8.62869 5.33186 8.625 5.37261C8.60965 5.45308 8.57819 5.52961 8.5325 5.59761C8.50881 5.63096 8.48292 5.6627 8.455 5.69261C8.39495 5.75155 8.32384 5.79802 8.24574 5.82934C8.16765 5.86066 8.08413 5.87622 8 5.87511ZM8 11.2501C7.86739 11.2501 7.74021 11.1974 7.64645 11.1037C7.55268 11.0099 7.5 10.8827 7.5 10.7501V7.50011H7.25C7.11739 7.50011 6.99021 7.44743 6.89645 7.35366C6.80268 7.25989 6.75 7.13272 6.75 7.00011C6.75 6.8675 6.80268 6.74032 6.89645 6.64655C6.99021 6.55279 7.11739 6.50011 7.25 6.50011H8C8.13261 6.50011 8.25979 6.55279 8.35355 6.64655C8.44732 6.74032 8.5 6.8675 8.5 7.00011V10.7501C8.5 10.8827 8.44732 11.0099 8.35355 11.1037C8.25979 11.1974 8.13261 11.2501 8 11.2501Z'
                                  fill='#9B9B9B'
                                />
                                <path
                                  d='M8.79995 11.25H7.19995C7.06734 11.25 6.94017 11.1973 6.8464 11.1036C6.75263 11.0098 6.69995 10.8826 6.69995 10.75C6.69995 10.6174 6.75263 10.4902 6.8464 10.3964C6.94017 10.3027 7.06734 10.25 7.19995 10.25H8.79995C8.93256 10.25 9.05974 10.3027 9.1535 10.3964C9.24727 10.4902 9.29995 10.6174 9.29995 10.75C9.29995 10.8826 9.24727 11.0098 9.1535 11.1036C9.05974 11.1973 8.93256 11.25 8.79995 11.25Z'
                                  fill='#9B9B9B'
                                />
                                <path
                                  d='M9.60502 14.1045H6.39502C5.20155 14.1045 4.05695 13.6304 3.21304 12.7865C2.36913 11.9426 1.89502 10.798 1.89502 9.60453V6.39453C1.89502 5.20106 2.36913 4.05646 3.21304 3.21255C4.05695 2.36864 5.20155 1.89453 6.39502 1.89453H9.60502C10.7985 1.89453 11.9431 2.36864 12.787 3.21255C13.6309 4.05646 14.105 5.20106 14.105 6.39453V9.60453C14.105 10.798 13.6309 11.9426 12.787 12.7865C11.9431 13.6304 10.7985 14.1045 9.60502 14.1045ZM6.39502 2.89453C5.46676 2.89453 4.57652 3.26328 3.92015 3.91966C3.26377 4.57604 2.89502 5.46627 2.89502 6.39453V9.60453C2.89502 10.5328 3.26377 11.423 3.92015 12.0794C4.57652 12.7358 5.46676 13.1045 6.39502 13.1045H9.60502C10.5333 13.1045 11.4235 12.7358 12.0799 12.0794C12.7363 11.423 13.105 10.5328 13.105 9.60453V6.39453C13.105 5.46627 12.7363 4.57604 12.0799 3.91966C11.4235 3.26328 10.5333 2.89453 9.60502 2.89453H6.39502Z'
                                  fill='#9B9B9B'
                                />
                              </svg>
                            </>
                          )}
                        </div>
                      )
                    ) : (
                      <div className='JobseekerId Requested'>
                        <span
                          title={
                            candidateDetailsHeader?.requested_jobseeker_id
                          }>
                          {candidateDetailsHeader?.requested_jobseeker_id}
                        </span>
                        <button
                          onClick={() => {
                            setUpdateJobseekerId((prev) => ({
                              ...prev,
                              showHide: true,
                            }));
                          }}>
                          Requested
                          <svg
                            xmlns='http://www.w3.org/2000/svg'
                            width='1rem'
                            height='1rem'
                            viewBox='0 0 12 12'
                            fill='none'>
                            <path
                              d='M10 5.74246L5.89623 9.84623C5.69121 10.0513 5.35879 10.0513 5.15377 9.84623C4.94874 9.64121 4.94874 9.30879 5.15377 9.10377L9.25754 5H7.5C7.22386 5 7 4.77614 7 4.5C7 4.22386 7.22386 4 7.5 4H10.5C10.7761 4 11 4.22386 11 4.5V7.5C11 7.77614 10.7761 8 10.5 8C10.2239 8 10 7.77614 10 7.5V5.74246ZM2 6.25754L6.10377 2.15377C6.30879 1.94874 6.64121 1.94874 6.84623 2.15377C7.05126 2.35879 7.05126 2.69121 6.84623 2.89623L2.74246 7H4.5C4.77614 7 5 7.22386 5 7.5C5 7.77614 4.77614 8 4.5 8H1.5C1.22386 8 1 7.77614 1 7.5V4.5C1 4.22386 1.22386 4 1.5 4C1.77614 4 2 4.22386 2 4.5V6.25754Z'
                              fill='var(--AccentColor)'
                            />
                          </svg>
                        </button>
                        <svg
                          xmlns='http://www.w3.org/2000/svg'
                          width='1.25rem'
                          height='1.25rem'
                          viewBox='0 0 16 16'
                          fill='none'
                          onMouseEnter={handleMouseEnterRequestedInfo}
                          onMouseLeave={handleMouseLeaveRequestedInfo}>
                          <path
                            d='M8 5.87511C7.91783 5.87544 7.83641 5.8595 7.76043 5.82821C7.68445 5.79691 7.61542 5.75089 7.55732 5.69279C7.49922 5.63468 7.45319 5.56565 7.4219 5.48968C7.39061 5.4137 7.37467 5.33228 7.375 5.25011C7.37545 5.20898 7.37964 5.16798 7.3875 5.12761C7.40285 5.04714 7.43431 4.9706 7.48 4.90261C7.50306 4.86877 7.52898 4.83699 7.5575 4.80761C7.67747 4.6953 7.83566 4.63281 8 4.63281C8.16434 4.63281 8.32253 4.6953 8.4425 4.80761C8.5585 4.9258 8.62395 5.0845 8.625 5.25011C8.62869 5.29086 8.62869 5.33186 8.625 5.37261C8.60965 5.45308 8.57819 5.52961 8.5325 5.59761C8.50881 5.63096 8.48292 5.6627 8.455 5.69261C8.39495 5.75155 8.32384 5.79802 8.24574 5.82934C8.16765 5.86066 8.08413 5.87622 8 5.87511ZM8 11.2501C7.86739 11.2501 7.74021 11.1974 7.64645 11.1037C7.55268 11.0099 7.5 10.8827 7.5 10.7501V7.50011H7.25C7.11739 7.50011 6.99021 7.44743 6.89645 7.35366C6.80268 7.25989 6.75 7.13272 6.75 7.00011C6.75 6.8675 6.80268 6.74032 6.89645 6.64655C6.99021 6.55279 7.11739 6.50011 7.25 6.50011H8C8.13261 6.50011 8.25979 6.55279 8.35355 6.64655C8.44732 6.74032 8.5 6.8675 8.5 7.00011V10.7501C8.5 10.8827 8.44732 11.0099 8.35355 11.1037C8.25979 11.1974 8.13261 11.2501 8 11.2501Z'
                            fill='#9B9B9B'
                          />
                          <path
                            d='M8.79995 11.25H7.19995C7.06734 11.25 6.94017 11.1973 6.8464 11.1036C6.75263 11.0098 6.69995 10.8826 6.69995 10.75C6.69995 10.6174 6.75263 10.4902 6.8464 10.3964C6.94017 10.3027 7.06734 10.25 7.19995 10.25H8.79995C8.93256 10.25 9.05974 10.3027 9.1535 10.3964C9.24727 10.4902 9.29995 10.6174 9.29995 10.75C9.29995 10.8826 9.24727 11.0098 9.1535 11.1036C9.05974 11.1973 8.93256 11.25 8.79995 11.25Z'
                            fill='#9B9B9B'
                          />
                          <path
                            d='M9.60502 14.1045H6.39502C5.20155 14.1045 4.05695 13.6304 3.21304 12.7865C2.36913 11.9426 1.89502 10.798 1.89502 9.60453V6.39453C1.89502 5.20106 2.36913 4.05646 3.21304 3.21255C4.05695 2.36864 5.20155 1.89453 6.39502 1.89453H9.60502C10.7985 1.89453 11.9431 2.36864 12.787 3.21255C13.6309 4.05646 14.105 5.20106 14.105 6.39453V9.60453C14.105 10.798 13.6309 11.9426 12.787 12.7865C11.9431 13.6304 10.7985 14.1045 9.60502 14.1045ZM6.39502 2.89453C5.46676 2.89453 4.57652 3.26328 3.92015 3.91966C3.26377 4.57604 2.89502 5.46627 2.89502 6.39453V9.60453C2.89502 10.5328 3.26377 11.423 3.92015 12.0794C4.57652 12.7358 5.46676 13.1045 6.39502 13.1045H9.60502C10.5333 13.1045 11.4235 12.7358 12.0799 12.0794C12.7363 11.423 13.105 10.5328 13.105 9.60453V6.39453C13.105 5.46627 12.7363 4.57604 12.0799 3.91966C11.4235 3.26328 10.5333 2.89453 9.60502 2.89453H6.39502Z'
                            fill='#9B9B9B'
                          />
                        </svg>
                      </div>
                    )}
                  </span>
                </div>
                <div className='LabelValue'>
                  <span className='Label'>
                    <svg
                      xmlns='http://www.w3.org/2000/svg'
                      width='1.25rem'
                      height='1.25rem'
                      viewBox='0 0 25 25'
                      fill='none'>
                      <path
                        d='M7.24766 16.3321C7.24766 15.9005 7.58345 15.5509 7.99766 15.5509H13.3371C13.7513 15.5509 14.0871 15.9005 14.0871 16.3321C14.0871 16.7636 13.7513 17.1134 13.3371 17.1134H7.99766C7.58345 17.1134 7.24766 16.7636 7.24766 16.3321ZM7.99766 12.5918C7.58345 12.5918 7.24766 12.9415 7.24766 13.373C7.24766 13.8045 7.58345 14.1543 7.99766 14.1543H10.9977C11.4119 14.1543 11.7477 13.8045 11.7477 13.373C11.7477 12.9415 11.4119 12.5918 10.9977 12.5918H7.99766Z'
                        fill='var(--TextColor)'
                      />
                      <path
                        fillRule='evenodd'
                        clipRule='evenodd'
                        d='M8.70374 3.90625C9.11795 3.90625 9.45374 4.25603 9.45374 4.6875V4.9515C9.82726 4.94791 10.2253 4.94791 10.6488 4.94792H13.7586C14.1821 4.94791 14.5802 4.94791 14.9537 4.9515V4.6875C14.9537 4.25603 15.2895 3.90625 15.7037 3.90625C16.118 3.90625 16.4537 4.25603 16.4537 4.6875V5.00289C16.6806 5.0195 16.8944 5.04112 17.0955 5.06929C17.9956 5.19535 18.7535 5.46503 19.3554 6.09203C19.9573 6.71903 20.2162 7.50848 20.3372 8.44609C20.4538 9.34919 20.4538 10.4974 20.4537 11.922V15.1415C20.4537 16.0833 20.4538 16.843 20.4004 17.4558C20.3455 18.0874 20.2292 18.6393 19.9513 19.1406C19.6222 19.7345 19.1488 20.2276 18.5787 20.5704C18.0975 20.8598 17.5677 20.9809 16.9613 21.0382C16.373 21.0937 15.6438 21.0938 14.7395 21.0938H10.6489C9.28128 21.0938 8.17895 21.0937 7.31199 20.9724C6.41188 20.8464 5.654 20.5767 5.05209 19.9497C4.45017 19.3226 4.19128 18.5332 4.07026 17.5956C3.9537 16.6925 3.95372 15.5443 3.95374 14.1197V11.922C3.95372 10.4974 3.9537 9.34918 4.07026 8.44609C4.19128 7.50848 4.45017 6.71903 5.05209 6.09203C5.654 5.46503 6.41188 5.19535 7.31199 5.06929C7.51311 5.04112 7.7269 5.0195 7.95374 5.00289V4.6875C7.95374 4.25603 8.28952 3.90625 8.70374 3.90625ZM14.9537 6.51428V6.77083C14.9537 7.2023 15.2895 7.55208 15.7037 7.55208C16.118 7.55208 16.4537 7.2023 16.4537 6.77083V6.56951C16.6101 6.58254 16.757 6.59845 16.8956 6.61786C17.6294 6.72062 18.018 6.90859 18.2947 7.19689C18.5715 7.48518 18.7519 7.88994 18.8506 8.65429C18.8692 8.7987 18.8845 8.95172 18.897 9.11458H5.51046C5.52297 8.95172 5.53825 8.7987 5.55688 8.65429C5.65554 7.88994 5.83598 7.48518 6.11275 7.19689C6.38951 6.90859 6.77808 6.72062 7.51186 6.61786C7.65048 6.59845 7.79739 6.58254 7.95374 6.56951V6.77083C7.95374 7.2023 8.28952 7.55208 8.70374 7.55208C9.11795 7.55208 9.45374 7.2023 9.45374 6.77083V6.51428C9.8301 6.51058 10.2447 6.51042 10.7037 6.51042H13.7037C14.1628 6.51042 14.5774 6.51058 14.9537 6.51428ZM5.45744 10.6771C5.4539 11.0692 5.45374 11.501 5.45374 11.9792V14.0625C5.45374 15.5577 5.45533 16.6005 5.55688 17.3874C5.65554 18.1518 5.83598 18.5565 6.11275 18.8448C6.38951 19.1331 6.77808 19.321 7.51186 19.4239C8.26721 19.5296 9.26832 19.5312 10.7037 19.5312H14.7037C15.6522 19.5312 16.3133 19.5305 16.8259 19.4821C17.3283 19.4347 17.6138 19.3465 17.8287 19.2173C18.1708 19.0116 18.4548 18.7156 18.6523 18.3594C18.7764 18.1355 18.861 17.838 18.9066 17.3148C18.953 16.7808 18.9537 16.0921 18.9537 15.1042V11.9792C18.9537 11.501 18.9536 11.0692 18.95 10.6771H5.45744Z'
                        fill='var(--TextColor)'
                      />
                    </svg>
                    <span>Submitted :</span>
                  </span>
                  <span className='Value'>
                    {candidateDetailsHeader?.submitted === "--"
                      ? "Not yet submitted"
                      : candidateDetailsHeader?.submitted}
                  </span>
                </div>
              </div>
            </section>
            <nav className='Navigation'>
              <span
                className={`Nav ${
                  currentTab === "ReportSummary" ? "Active" : ""
                }`}
                onClick={() => {
                  setCurrentTab("ReportSummary");
                }}>
                Report Summary
              </span>
              <span
                className={`Nav ${currentTab === "History" ? "Active" : ""}`}
                onClick={() => {
                  setCurrentTab("History");
                }}>
                History
              </span>
              <span
                className={`Nav ${currentTab === "Documents" ? "Active" : ""}`}
                onClick={() => {
                  setCurrentTab("Documents");
                }}>
                Documents
              </span>
              <span
                className={`Nav ${
                  currentTab === "ApplicantData" ? "Active" : ""
                }`}
                onClick={() => {
                  setCurrentTab("ApplicantData");
                }}>
                Applicant Data
              </span>
              <span
                className={`Nav ${
                  currentTab === "ReportDetails" ? "Active" : ""
                }`}
                onClick={() => {
                  setCurrentTab("ReportDetails");
                }}>
                Report Details
              </span>
              <span
                className={`Nav ${currentTab === "Requests" ? "Active" : ""}`}
                onClick={() => {
                  setCurrentTab("Requests");
                }}>
                Requests
              </span>
            </nav>
          </header>
          <section className='CheckDetails'>
            {rendeCandidateDetailsComponent()}
          </section>
        </>
      )}
      {ShowUpdateTooltip.showHide && (
        <div
          className='UpdateToolTip'
          style={{
            top: `calc(${ShowUpdateTooltip.y}px - 6.5rem)`,
            left: `calc(${ShowUpdateTooltip.x}px - 22rem)`,
          }}>
          <img
            src={UpdateTooltip}
            alt='Update Jobseeker Id'
          />
          <div>
            <h3>Update Job Seeker ID</h3>
            <p>
              You can request to update the Job Seeker Id. Note: Only one update
              request can be active at a time. Once approved, you'll be able to
              submit a new request if needed.
            </p>
          </div>
        </div>
      )}
      {ShowRequestTooltip.showHide && (
        <div
          className='UpdateToolTip'
          style={{
            top: `calc(${ShowRequestTooltip.y}px - 6.5rem)`,
            left: `calc(${ShowRequestTooltip.x}px - 22rem)`,
          }}>
          <img
            src={RequestedTooltip}
            alt='Requested Jobseeker Id'
          />
          <div>
            <h3>Pending Approval</h3>
            <p>
              Your update request has been sent to the admin. Once approved, the
              Job Seeker Id will be updated.
            </p>
            <li>Current Id: {candidateDetailsHeader?.job_seeker_id}</li>
            <li>
              Requested Id: {candidateDetailsHeader?.requested_jobseeker_id}
            </li>
          </div>
        </div>
      )}
    </main>
  );
};

export default CandidateDetail;
